import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RevokeUnitFromExecutorService {

  constructor(
    private http: HttpClient
  ) { }

  public revoke(unitId: number, executorId: number) {
    return this.http.post(
      environment.apiBasepoint + 'revoke-unit-from-executor',
      {unitId: unitId, executorId: executorId},
      {observe: 'body'}
    );
  }
}
